import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Card,
    List
} from "reactstrap";
import React from 'react';
import Link from 'next/link';
import styles from './styles.module.scss';

export default function SimilarJobs({
    global,
    pathPrefix,
    heading,
    all_similarJob,
    customClass
}) {
    return (
        all_similarJob.length >= 1 && (
            <div className={`${styles.root} ${customClass}`}>
                <div className="content-wrapper bg-light rounded-3 border">
                    <h5 className="heading p-4 pb-0 m-0">
                        <strong>
                            <SourceFlowText global={global} path={`${pathPrefix}.heading`} type="html">
                                {heading}
                            </SourceFlowText>
                        </strong>
                    </h5>
                    <List type="unstyled" className="m-0">
                        {all_similarJob?.map((post, index) => (
                            <li className="p-4" key={index}>
                                <Link href={`/jobs/${post.url_slug}`} key={index}>
                                    <a className="text-decoration-none">
                                        <h5 className="fs-6 mb-1"><strong>{post.title}</strong></h5>
                                        {post?.salary_package ?
                                            <div className="job-salary-package mb-1">{post.salary_package}</div> : ""}
                                        {post?.location ?
                                            <div className="job-location">{post.location}</div> : ""}
                                    </a>
                                </Link>
                            </li>

                        ))}
                    </List>
                </div>
            </div>
        )
    )
}

